module.exports = __webpack_public_path__ + "img/icon_422A8652_2048px.c7b67760.jpg";